import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import withIntl from 'hoc/withIntl';
import ErrorBoundary from 'components/ErrorBoundary';

import SignOn from './SignOn';

if (window.bundleLocation) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.bundleLocation;
}

const injectReactLogin = (selector, parameters) => {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }
  const App = withIntl(SignOn);

  render(
    <StrictMode>
      <ErrorBoundary>
        <App {...parameters} />
      </ErrorBoundary>
    </StrictMode>,
    element,
  );
};

window.XM_injectReactLogin = injectReactLogin;
